(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('custom-menu')) {
    customElements.define(
      'custom-menu',
      class CustomMenu extends HTMLElement {
        connectedCallback() {
          this.details = Array.from(this.querySelectorAll('.custom-menu__details'));
          if (!this.details.length) return;

          this.closeTimer = null;
          this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
          this.hoverMode = this.dataset.trigger === 'hover' && this.canHover;

          this.onToggle = this.onToggle.bind(this);
          this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
          this.onKeydown = this.onKeydown.bind(this);
          this.onFocusOut = this.onFocusOut.bind(this);

          this.details.forEach((details) => {
            details.addEventListener('toggle', this.onToggle);

            if (!this.hoverMode) return;

            details.addEventListener('pointerenter', () => {
              clearTimeout(this.closeTimer);
              this.open(details);
            });

            details.addEventListener('pointerleave', () => {
              clearTimeout(this.closeTimer);
              this.closeTimer = setTimeout(() => this.close(details), 160);
            });

            // In hover mode a click on the parent should follow its own link
            // rather than just toggling a panel that is already open.
            const summary = details.querySelector('summary');
            summary?.addEventListener('click', (event) => {
              const url = details.dataset.url;
              if (!url || url === '#') return;
              event.preventDefault();
              window.location.href = url;
            });
          });

          this.addEventListener('keydown', this.onKeydown);
          this.addEventListener('focusout', this.onFocusOut);
          document.addEventListener('pointerdown', this.onDocumentPointerDown);
        }

        disconnectedCallback() {
          clearTimeout(this.closeTimer);
          document.removeEventListener('pointerdown', this.onDocumentPointerDown);
        }

        open(details) {
          if (details.open) return;
          details.open = true;
        }

        close(details) {
          if (!details.open) return;
          details.open = false;
        }

        closeAll(except) {
          this.details.forEach((details) => {
            if (details !== except) this.close(details);
          });
        }

        onToggle(event) {
          const details = event.target;
          if (!details.open) return;

          this.closeAll(details);
          this.position(details);
        }

        /* Flip the panel to the right edge if it would spill off screen. */
        position(details) {
          const panel = details.querySelector('.custom-menu__panel');
          if (!panel) return;

          panel.removeAttribute('data-flip');

          const rect = panel.getBoundingClientRect();
          const overflowsRight = rect.right > window.innerWidth - 8;
          const roomOnLeft = rect.width < details.getBoundingClientRect().right - 8;

          if (overflowsRight && roomOnLeft) {
            panel.setAttribute('data-flip', '');
          }
        }

        onKeydown(event) {
          if (event.key !== 'Escape') return;

          const openDetails = this.details.find((details) => details.open);
          if (!openDetails) return;

          this.close(openDetails);
          openDetails.querySelector('summary')?.focus();
        }

        onFocusOut(event) {
          requestAnimationFrame(() => {
            if (this.contains(document.activeElement)) return;
            this.closeAll();
          });
        }

        onDocumentPointerDown(event) {
          if (this.contains(event.target)) return;
          this.closeAll();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["videos-metaobject"] && !Shopify.designMode) return;
  try {
    // Document-level delegation so handlers survive Horizon's editor
  // re-renders and work across multiple block instances.
  if (!window.__videoLightboxInit) {
    window.__videoLightboxInit = true;

    const getIframe = (dialog) =>
      dialog.querySelector('[data-video-lightbox-iframe]');

    document.addEventListener('click', (event) => {
      // Open
      const trigger = event.target.closest('[data-video-trigger]');
      if (trigger) {
        const dialog = document.getElementById(
          trigger.getAttribute('aria-controls')
        );
        if (!dialog) return;

        const iframe = getIframe(dialog);
        iframe.title = trigger.dataset.videoTitle || 'Video';
        iframe.src =
          'https://www.youtube-nocookie.com/embed/' +
          encodeURIComponent(trigger.dataset.videoId) +
          '?autoplay=1&rel=0&playsinline=1';

        dialog.showModal();
        return;
      }

      // Close button
      const closeBtn = event.target.closest('[data-video-lightbox-close]');
      if (closeBtn) {
        closeBtn.closest('dialog')?.close();
        return;
      }

      // Backdrop click — the dialog element itself is only the click
      // target when the click lands outside __inner.
      if (
        event.target instanceof HTMLDialogElement &&
        event.target.hasAttribute('data-video-lightbox')
      ) {
        event.target.close();
      }
    });

    // 'close' doesn't bubble, so listen in the capture phase.
    // Clearing src stops playback immediately (Esc key included).
    document.addEventListener(
      'close',
      (event) => {
        if (
          event.target instanceof HTMLDialogElement &&
          event.target.hasAttribute('data-video-lightbox')
        ) {
          const iframe = getIframe(event.target);
          if (iframe) iframe.src = '';
        }
      },
      true
    );
  }
  } catch(e) { console.error(e); }
})();

})();
